// The six songs (§13.4) and which one each map plays.
import { MapId } from '@shared/ids';
import type { SongDef } from '../songTypes';
import { CAKE } from './cake';
import { LOUNGE } from './lounge';
import { PINBALL } from './pinball';
import { PODIUM } from './podium';
import { SPIN } from './spin';
import { TEACUP } from './teacup';

export type SongId = SongDef['id'];

export const SONGS: Readonly<Record<SongId, SongDef>> = {
  lounge: LOUNGE, teacup: TEACUP, pinball: PINBALL, cake: CAKE, spin: SPIN, podium: PODIUM,
};

export const SONG_IDS: readonly SongId[] = ['lounge', 'teacup', 'pinball', 'cake', 'spin', 'podium'];

/** The song a map's rounds play (Lobby: lounge; Podium: podium). */
export function songForMap(mapId: MapId): SongId {
  switch (mapId) {
    case MapId.TEACUP: return 'teacup';
    case MapId.PINBALL: return 'pinball';
    case MapId.CAKE: return 'cake';
    case MapId.SPIN: return 'spin';
    case MapId.PODIUM: return 'podium';
    default: return 'lounge';
  }
}
